import { sendGTMEvent } from '@next/third-parties/google'

const signalEvent = (action: string) => {
  sendGTMEvent({ event: 'app_event', app_event_name: action })
}

export default {
  signalEvent,
}
